import script from "./CreateButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateButton.vue?vue&type=script&setup=true&lang=js"

import "./CreateButton.vue?vue&type=style&index=0&id=1ab70670&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ab70670"]])

export default __exports__